module.exports = __webpack_public_path__ + "assets/img/serve11.be22125d.png";